import React, { FC, memo } from 'react'
import { styled } from '@mui/material'

interface FilterButtonProps {
  onClick?: (() => void) | ((e: React.MouseEvent<HTMLElement>) => void)
  icon: string
  width?: number | string
  height?: number | string
  fontSize?: string
  title?: string
}

const FilterButtonStyled = styled('button')<{ fontSize?: string }>(
  ({ theme, fontSize }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.grey[500]}`,
    fontFamily: theme.typography.fontFamily,
    fontSize: fontSize || '12px',
    fontWeight: 600,
    width: 93,
    height: 42,
    color: theme.palette.text.primary,
    borderRadius: '6px',
    cursor: 'pointer',
    padding: '0',
    '&:hover': {
      background: theme.palette.grey[200],
    },
    '&:active': {
      background: theme.palette.grey[300],
    },
    [theme.breakpoints.down('md')]: {
      width: '98%',
    },
  }),
)

export const FilterButton: FC<FilterButtonProps> = memo(
  ({ onClick, icon, height, width, fontSize, title }) => (
    <FilterButtonStyled onClick={onClick} fontSize={fontSize}>
      <img src={icon} alt="Filter" width={width} height={height} />
      {title ?? 'Filters'}
    </FilterButtonStyled>
  ),
)

FilterButton.displayName = 'FilterButton'
